import Keyball39 from '../img/Keyball39.webp';
import Physbone from '../img/Physbone.webp';
import UdonLLM from '../img/UdonLLM.png';

const blogTopics = [
  {
    title: '自作キーボード',
    image: Keyball39,
    alt: '自作キーボード Keyball39',
    category: 'Keyboard',
    summary:
      'Keyball39を組み立て、分割キーボードとトラックボールを組み合わせた自作キーボード環境を構築しました。',
    url: 'https://note.com/rin0700/n/n63460066bf88',
    external: true,
  },
  {
    title: 'VRC PhysBone Collider Setup',
    image: Physbone,
    alt: 'VRC PhysBone Collider Setup',
    category: 'VRChat',
    summary:
      'VRChatアバター向けに、PhysBoneのコライダー設定とセットアップ手順をまとめました。',
    url: 'https://note.com/rin0700/n/n97be8d908e10',
    external: true,
  },
  {
    title: 'UdonLLM',
    image: UdonLLM,
    alt: 'UdonLLM ローカルLLM構築イメージ',
    category: 'Udon',
    summary:
      'VRChat / UdonSharpから扱えるローカルLLM環境を構築し、外部APIに依存しない会話システムの検証を行いました。',
    url: '/blog/80c93bb1-9085-47bf-92b7-c422d7b04ed3',
    external: false,
  },
];

export default blogTopics;
